"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerIframe = exports.suscribeAndUnsuscribeHandlers = exports.createHandler = void 0;
var dispatchMessage = function (message) {
    if (window.parent === window) {
        return;
    }
    if (!("postMessage" in window.parent)) {
        console.error("can not send a event", message);
    }
    logger("dispatched", message.type, message.payload);
    window.parent.postMessage(message, "*");
};
var createHandler = function (type, callback) {
    return function (message) {
        if (message.type === type) {
            logger("received", message.type, message.payload);
            callback(message.payload);
        }
    };
};
exports.createHandler = createHandler;
var logger = function (from, type, payload) {
    if (isLogged) {
        var color = from === "dispatched" ? "#f5ec7f" : "#00cc35";
        console.group("%c " + from, "color: " + color);
        console.log("👉 ", type);
        var stringPayload = JSON.stringify(payload);
        stringPayload && console.log("📦  " + stringPayload);
        console.groupEnd();
    }
};
var suscribeAndUnsuscribeHandlers = function (handlers, handler) {
    handlers.push(handler);
    return function () {
        handlers.splice(handlers.indexOf(handler), 1);
    };
};
exports.suscribeAndUnsuscribeHandlers = suscribeAndUnsuscribeHandlers;
var isLogged = false;
var registerIframe = function (log) {
    if (log === void 0) { log = false; }
    isLogged = log;
    var handlers = [];
    window.addEventListener("message", function (event) {
        handlers.forEach(function (handler) { return handler(event.data); });
    });
    return {
        dispatch: dispatchMessage,
        suscribe: function (type, callback) {
            var handler = (0, exports.createHandler)(type, callback);
            return (0, exports.suscribeAndUnsuscribeHandlers)(handlers, handler);
        },
    };
};
exports.registerIframe = registerIframe;
